import { NeoState } from '../Reducers.interface';

export const selectImageUpload = (state: NeoState) => state.app.imageUpload;
